<script>
    // @ts-nocheck

    import { createEventDispatcher } from "svelte";
    import Icon from "$lib/UI/Icon.svelte";
    import ActionItem from "./ActionItem.svelte";

    export let id = undefined;
    export let title = undefined;
    export let elucidation = undefined;
    export let icon = undefined;
    export let action = undefined;
    export let styleClass = "action-default";
    export let tooltip = undefined;
    export let items = [];
    export let menuVisible = undefined;
    export let menuPop = undefined;
    export let disabled = false;

    const dispatch = createEventDispatcher();

    function doActionSelect(event) {
        if (!disabled) {
            if (!!items && items.length > 0) {
                menuVisible = true;
            } else {
                menuVisible = false;
                dispatch("select", { id: id, action: action });
            }
        }
    }

    function doSelectItem(item) {
        if (!disabled) {
            dispatch("select", { id: item.id, action: item.action });
            menuVisible = false;
        }
    }

    function closeModal() {
        menuVisible = false;
    }

    function getPop(s) {
        if (!!menuPop && menuPop === "left") {
            return "action-items-pop-left";
        } else if (!!menuPop && menuPop === "top") {
            return "action-items-pop-top";
        }
        return "action-items";
    }
</script>

{#if menuVisible}
    <div class="modal-backdrop" on:click={closeModal} />
{/if}

<div
    {id}
    title={tooltip}
    class="action-tile {styleClass} {styleClass}-color"
    class:enabled={!disabled}
    on:click={doActionSelect}
>
    <div class="static-tile">
        <div class="tile-name">
            {title}
        </div>
        <div class="tile-icon">
            <Icon {icon} size="large" />
        </div>
        <div class="tile-elucidation">
            {elucidation}
        </div>
    </div>
    {#if menuVisible}
        {#if !!items}
            <div class={getPop(menuPop)}>
                {#each items as item, idx (item.id)}
                    <ActionItem
                        id={item.id}
                        title={item.title}
                        icon={item.icon}
                        top={item.top}
                        first={idx === 0}
                        description={item.description}
                        on:select={() => doSelectItem(item)}
                    />
                {/each}
            </div>
        {/if}
    {/if}
</div>

<style>
    .action-tile {
        width: 250px;
        height: 160px;
        border-radius: 30px;
        box-shadow: var(--box-shadow);
        margin: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .static-tile {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-height: 130px;
        justify-content: space-between;
       
    }

    .tile-name {
        font-size: larger;
    }

    .tile-elucidation {
        font-size: smaller;
        text-align: center;
        width: 80%;
    }

    .tile-icon {
        margin: 5px;
    }
    .action {
        margin: 1rem 1rem 0 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .action-small {
        margin: 0 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .action-selected {
        border: 2px solid;
    }

    .action-tile:hover.enabled {
        cursor: pointer;
    }

    .action-items {
        border: solid gray 1px;
        border-radius: 5px;
        padding: 5px;
        position: absolute;
        top: 0px;
        left: 50px;
        background: var(--background-active);
        z-index: 100;
        width: 250px;
    }

    .action-items-pop-top {
        border: solid gray 1px;
        border-radius: 5px;
        padding: 5px;
        position: absolute;
        bottom: 0px;
        left: 50px;
        background: var(--background-active);
        z-index: 100;
        width: 250px;
    }
    .action-items-pop-left {
        border: solid gray 1px;
        border-radius: 5px;
        padding: 5px;
        position: absolute;
        top: 20px;
        left: -240px;
        background: var(--background-active);
        z-index: 100;
        width: 250px;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        z-index: 10;
    }

    .tile-title {
        font-size: smaller;
        color: white;
    }

    .tile-icon {
        margin: 5px;
    }

    .action-small-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 30px;
        width: 30px;
        border-radius: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .action-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 50px;
        width: 50px;
        border-radius: 6px;
        justify-content: center;
    }

    @media screen and (max-width: 700px) {
        .action {
            margin: 1rem 1rem 0 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: initial;
        }

        .action-items {
            border: solid gray 1px;
            border-radius: 5px;
            padding: 5px;
            position: absolute;
            top: 110px;
            left: 50px;
            background: var(--background-active);
            z-index: 100;
            width: 250px;
        }
    }
</style>
